// Apply popstate to nav tabs
// Will apply url hashtags on tab change and will show appropriate tab if hashtag

jQuery(function() {
	var hash = window.location.hash;
	hash && jQuery('.nav-tabs a[href="' + hash + '"]').tab('show');

	// add a hash to the URL when the user clicks on a tab
	jQuery('a[data-toggle="tab"]').on('click', function(e) {
		history.pushState(null, null, jQuery(this).attr('href'));
	});
	// navigate to a tab when the history changes
	window.addEventListener("popstate", function(e) {
		var activeTab = jQuery('[href=' + location.hash + ']');
		if (activeTab.length) {
			activeTab.tab('show');
		} else {
			jQuery('.nav-tabs a:first').tab('show');
		}
	});
});
